import {AnyAction} from "redux";
import * as _ from "lodash";
import {getAllPowerSourcesData, IPowerSource} from "../../../data/data";
import {countPowerSources, getPopulatedPowerSources} from "../powerSources";
import {createSelector} from "reselect";


/**
 * get the total cost per mw of all power sources
 */
export const getCostPerMw = createSelector(

    [countPowerSources, getPopulatedPowerSources],

    (count: number, power_sources: IPowerSource[]) =>
    {
        if (! power_sources.length) return 0;

        // const pc: number = _.clamp(_.sumBy(power_sources, 'cost-per-mw') / 250, 0, 1);
        //
        // return pc * 100;

        // console.log('getCostEfficiency', _.sumBy(power_sources, 'cost-per-mw') / count);

        return _.sumBy(power_sources, 'cost-per-mw') / count;

    }
);


/**
 * get the target cost per m
 */
export const getTargetCostPerMw = createSelector(

    [getAllPowerSourcesData],

    (power_sources: IPowerSource[]) =>
    {
        if (! power_sources.length) return 0;

        return _.max(_.map(power_sources, 'cost-per-mw'));
    }
);


//  define the initial state

const initialState: number = 0;


/**
 * reducer: set the current cost efficiency
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function costPerMw(state: number = initialState, action: AnyAction) : number
{
    switch (action.type)
    {
        default:

            return state;
    }
}


// WEBPACK FOOTER //
// ./src/ts/store/reducers/outputs/costPerMw.ts